// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconNotificationError: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="#E4104E"
                d="M4.44618395,0.59375 C4.82191781,0.21875 5.35420744,0 5.88649706,0 L10.1135029,0 C10.6457926,0 11.1780822,0.21875 11.553816,0.59375 L15.4363992,4.46875 C15.8121331,4.84375 16,5.34375 16,5.875 L16,10.125 C16,10.65625 15.8121331,11.15625 15.4363992,11.53125 L11.553816,15.40625 C11.1780822,15.78125 10.6457926,16 10.1135029,16 L5.88649706,16 C5.35420744,16 4.82191781,15.78125 4.44618395,15.40625 L0.563600783,11.53125 C0.187866928,11.15625 0,10.65625 0,10.125 L0,5.875 C0,5.34375 0.187866928,4.84375 0.563600783,4.46875 L4.44618395,0.59375 Z M5.22896282,5.21875 C4.91585127,5.5 4.91585127,6 5.22896282,6.28125 L6.95107632,8 L5.22896282,9.71875 C4.91585127,10 4.91585127,10.5 5.22896282,10.78125 C5.51076321,11.0625 5.98043053,11.0625 6.26223092,10.78125 L7.98434442,9.0625 L9.70645793,10.78125 C10.0195695,11.0625 10.4892368,11.0625 10.7710372,10.78125 C11.0841487,10.46875 11.0841487,10 10.7710372,9.71875 L9.04892368,8 L10.7710372,6.28125 C11.0841487,6 11.0841487,5.5 10.7710372,5.21875 C10.4892368,4.9375 10.0195695,4.9375 9.70645793,5.21875 L7.98434442,6.9375 L6.26223092,5.21875 C5.98043053,4.9375 5.51076321,4.9375 5.22896282,5.21875 Z"
            />
        </svg>
    );
};

export default React.memo(IconNotificationError);
